import { useState, useEffect } from 'react'
import { SeriesResponse } from '../types'

type UseSeriesImagesProps = {
  seriesDetails: SeriesResponse | null
  isEditMode: boolean
  isLoading: boolean
}

function getImageBasePath(path: string): 'images' | 'public' {
  return path.includes('originals') ? 'images' : 'public'
}

export function useSeriesImages({
  seriesDetails,
  isEditMode,
  isLoading,
}: UseSeriesImagesProps) {
  let [banner, setBanner] = useState<File | undefined>(undefined)
  let [thumbnail, setThumbnail] = useState<File | undefined>(undefined)
  let [mobileBanner, setMobileBanner] = useState<File | undefined>(undefined)
  let [existingBanner, setExistingBanner] = useState('')
  let [existingThumbnail, setExistingThumbnail] = useState('')
  let [existingMobileBanner, setExistingMobileBanner] = useState('')
  let [bannerBasePath, setBannerBasePath] = useState<'images' | 'public'>(
    'images',
  )
  let [thumbnailBasePath, setThumbnailBasePath] = useState<'images' | 'public'>(
    'images',
  )
  let [mobileBannerBasePath, setMobileBannerBasePath] = useState<
    'images' | 'public'
  >('images')

  useEffect(() => {
    if (isEditMode && seriesDetails && !isLoading) {
      setBanner(undefined)
      setThumbnail(undefined)
      setMobileBanner(undefined)

      let b = seriesDetails.banner ?? ''
      let t = seriesDetails.thumbnail ?? ''
      let mb = seriesDetails.mobileBanner ?? ''

      setExistingBanner(b)
      setExistingThumbnail(t)
      setExistingMobileBanner(mb)
      setBannerBasePath(b ? getImageBasePath(b) : 'images')
      setThumbnailBasePath(t ? getImageBasePath(t) : 'images')
      setMobileBannerBasePath(mb ? getImageBasePath(mb) : 'images')
    } else if (!isEditMode) {
      setBanner(undefined)
      setThumbnail(undefined)
      setMobileBanner(undefined)
      setExistingBanner('')
      setExistingThumbnail('')
      setExistingMobileBanner('')
    }
  }, [isEditMode, seriesDetails, isLoading])

  return {
    banner,
    setBanner,
    thumbnail,
    setThumbnail,
    mobileBanner,
    setMobileBanner,
    existingBanner,
    existingThumbnail,
    existingMobileBanner,
    bannerBasePath,
    thumbnailBasePath,
    mobileBannerBasePath,
  }
}
